import { render, staticRenderFns } from "./KneeHipReport.vue?vue&type=template&id=07b95178"
import script from "./KneeHipReport.vue?vue&type=script&lang=js"
export * from "./KneeHipReport.vue?vue&type=script&lang=js"
import style0 from "./KneeHipReport.vue?vue&type=style&index=0&id=07b95178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports